import React, {useState, useEffect, useContext } from 'react';
import { IonModal, IonGrid, IonRow, IonCol, IonButton, IonSlides, IonSlide, IonContent, IonHeader } from '@ionic/react';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

import '../css/zInternal_css.css';
import '../../../../css/qavaApp.css';
import { ViewAttachement_ExpenseImageModal } from './Modal_ViewAttachement_ExpenseImage';
import { AddExpenseModal_Projects } from './Modal_AddExpense_Projects';
import { ViewExpensesModal_Projects } from './Modal_ViewExpenses_Projects';


export function InvoiceDetailsModal_Project(props) {


    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [viewInvoiceDetailData, setViewInvoiceDetailData] = useState([]);


    let [expenseID, setExpenseID] = useState(null);
    let [totalAmount, setTotalAmount] = useState(null);
    let [paymentType, setPaymentType] = useState(null);
    let [imageAttachement, setImageAttachement] = useState(null);
    let [viewAttachementModal, setViewAttachemntModal] = useState(false);

    let [addExpenseModal, setAddExpenseModal] = useState(false);
    let [viewExpenseModal, setViewExpenseModal] = useState(true);




   //getOccupiedRoomDetailData(instant_checkInRoomID) {
    useEffect(() => {



        if(props.openModal == true)
        {

            const requestOptions = {
                method: 'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    //'cookie': 'cookie',
                },
                body: JSON.stringify({
                    Tracker: '74002A_view_project_invoice_details',
                    user: acctID,
                    xProjectID: props.data.projectID,
                    xInvoiceID: props.data.invoiceID,
                    sessionID: sessionID,
    
                }),
            }
        
            
            fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
            .then(res => res.text())
            .then(res => {
        
                let rows = res.toString().split('~~~');
        
                for (let rownum = 0; rownum < rows.length - 1; ++rownum)
                {
                    let cols = rows[rownum].split('|');


                    setViewInvoiceDetailData((prevViewInvoiceDetailData) => {
                        return prevViewInvoiceDetailData.concat({
                           // expenseID: cols[0],
                            invoiceName: cols[1],
                            supplierPhoneNumber: cols[4],
                            invoiceDescription: cols[5],
                            //dateLogged: new Date(cols[4]).toISOString().substr(0, 10),
                            //unitAmount: parseFloat(cols[5]).toFixed(2),
                            //quantity: cols[6],
                            totalAmount: parseFloat(cols[2]).toFixed(2),
                           // paymentType: cols[8],
                            attachment: cols[0],
                        })

                    });
        
                }    
            })
        }
        
    }, [props.openModal]);

    function viewExpenseAttachmentHandler(event) {


        setTotalAmount(event[3]);
        setPaymentType(event[4]);
        setImageAttachement(event[5]);

        setViewAttachemntModal(event[0]);

        //setRoomID(event[1]);
        //setRoomSalePrice(event[2]);
    }

    function closeModalHandler() {

        setViewInvoiceDetailData([]);
        props.closeModal(false);
    }

    //alert(props.data.supplier_name);
    //alert(props.data.supplier_phoneNumber);

    return (
        <React.Fragment>
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
        <IonHeader className='grid_checkInHeader'>
            <IonGrid class='gridModalTopInfo'>
                    <IonRow>
                        <IonCol> Invoice ID</IonCol>
                        <IonCol> Total Amount</IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol> {props.data.invoiceID} </IonCol>
                        <IonCol> {props.data.expenses} </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol> <IonButton onClick={() => setAddExpenseModal(true)}>Add</IonButton></IonCol>
                    </IonRow>
            </IonGrid>
        </IonHeader>
        <IonContent className='projectDetails_invoices'>
            {viewInvoiceDetailData.map((detailData) =>   {
            return (
            <IonGrid >
                <IonRow class='gridResultHeaders'>
                    <IonCol class='gridResultColumns'>Category</IonCol>
                    <IonCol class='gridResultColumns'>Value</IonCol>
                    <IonCol class='gridResultColumns'>Action</IonCol>
                </IonRow>
                <IonRow class='gridResultBody'>
                    <IonCol class='gridResultHeaders'>Invoice Name</IonCol>
                    <IonCol class='gridResultColumns'>{detailData.invoiceName}</IonCol>
                    <IonCol class='gridResultColumns'>
                        <IonButton class='gridResultColumnButton'> - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow class='gridResultBody'>
                    <IonCol class='gridResultHeaders'>Supplier Phone</IonCol>
                    <IonCol class='gridResultColumns'>{detailData.supplierPhoneNumber}</IonCol>
                    <IonCol class='gridResultColumns'>
                        <IonButton class='gridResultColumnButton'> - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow class='gridResultBody'>
                    <IonCol class='gridResultHeaders'>Total Amount</IonCol>
                    <IonCol class='gridResultColumns'>{detailData.totalAmount}</IonCol>
                    <IonCol class='gridResultColumns'>
                        <IonButton class='gridResultColumnButton'> - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow class='gridResultBody'>
                    <IonCol class='gridResultHeaders'>Description</IonCol>
                    <IonCol style={{fontSize: 'small'}}>{detailData.invoiceDescription}</IonCol>
                    <IonCol class='gridResultColumns'>
                        <IonButton class='gridResultColumnButton'> - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow class='gridResultBody'>
                    <IonCol class='gridResultHeaders'>Attachment</IonCol>
                    <IonCol class='gridResultColumns'>{'Expense Attachment'}</IonCol>
                    <IonCol class='gridResultColumns'>
                        <ViewAttachement_ExpenseImageModal openModal={ viewAttachementModal } closeModal={() => setViewAttachemntModal(false)} data={{
                                                totalAmount: detailData.totalAmount, 
                                                fileLocation: detailData.attachment, 
                                                }}></ViewAttachement_ExpenseImageModal>

                        <IonButton className='appListButton' onClick={() => viewExpenseAttachmentHandler([true, detailData.unitAmount, detailData.quantity, detailData.totalAmount, detailData.paymentType, detailData.attachment])}> View </IonButton>

                    </IonCol>
                </IonRow>
            </IonGrid>
                    )
                }
            )}

        <AddExpenseModal_Projects  openModal={ addExpenseModal } closeModal={() => setAddExpenseModal(false)} data={{
                                            projectID: props.data.projectID, 
                                            invoiceID: props.data.invoiceID, 
                                            customerInvoiceID: props.data.customerInvoiceID, 
                                            estimates: props.data.estimates,
                                            expenses: props.data.expenses,
                                            supplier_name: props.data.supplier_name,
                                            supplier_phoneNumber: props.data.supplier_phoneNumber,
                                            }}></AddExpenseModal_Projects>

        <ViewExpensesModal_Projects  openModal={ viewExpenseModal } closeModal={() => setViewExpenseModal(false)}data={{
                                            projectID: props.data.projectID, 
                                            estimates: props.data.estimates,
                                            expenses: props.data.expenses,
                                            }}></ViewExpensesModal_Projects>

        </IonContent>

        <IonGrid class='modal_footer_button_center'>
            <IonButton onClick={closeModalHandler}> Close </IonButton>
        </IonGrid>
    </IonModal>) : null}
    </React.Fragment>
    )
}